/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillChargePointDeviceIdsResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeBackfillChargePointDeviceIdsCommand, serializeBackfillChargePointDeviceIdsResult, type BackfillChargePointDeviceIdsCommand, type BackfillChargePointDeviceIdsResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /backfills/chargepoint-device-ids
 */
export interface ChargepointDeviceIdsRequestBuilder extends BaseRequestBuilder<ChargepointDeviceIdsRequestBuilder> {
    /**
     * BackfillChargePointDeviceIds
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillChargePointDeviceIdsResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: BackfillChargePointDeviceIdsCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillChargePointDeviceIdsResult | undefined>;
    /**
     * BackfillChargePointDeviceIds
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BackfillChargePointDeviceIdsCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargepointDeviceIdsRequestBuilderUriTemplate = "{+baseurl}/backfills/chargepoint-device-ids";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargepointDeviceIdsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ChargepointDeviceIdsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillChargePointDeviceIdsResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBackfillChargePointDeviceIdsCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
